import LightHouseTags from '../../services/light-house/LightHouseTags';
import pitchHubHelpIcon from '../../assets/icons/PitchHub-help.svg';

export const changeZindex = (value = '2147483000') => {
  const launcher = document.getElementById('Launcher');
  if (launcher) {
    launcher.style.zIndex = value;
  }
};

const setIsActiveWidget = (isActive: boolean) => {
  const launcher = document.getElementById('Launcher');
  if (launcher) {
    launcher.style.display = isActive ? 'block' : 'none';
    if (!isActive) {
      if (window.intercomSettings && window.Intercom && window.hdlh) {
        window.hdlh.isNavigate = false;
        window.intercomSettings.hide_default_launcher = false;
        window.Intercom('update');
      }
    }
  }
};

const lightHouse = () => {
  const tags = LightHouseTags.getByPath({ pathname: window.location.pathname });

  if (window.Lighthouse !== undefined) {
    if (window.hdlh && !window.hdlh.isVisible) {
      window.Lighthouse.showButton();
    }
    if (window.hdlh) {
      window.hdlh.suggestions = tags;
    }
    window.Lighthouse.reload();

    if (!window.hdlh?.isActiveLightHouse) {
      setIsActiveWidget(false);
    }
    if (window.hdlh && !window.hdlh.isOpen) {
      changeZindex();
    }
    return;
  }
  if (window.hdlh) {
    return;
  }
  const token = process.env.REACT_APP_LIGHT_HOUSE_TOKEN;
  // Lighthouse for Helpdocs.io
  // @ts-ignore
  window.hdlh = {
    widget_key: token,
    launcher_button_image: pitchHubHelpIcon,
    isActiveLightHouse: false,
    isNavigate: false,
    isVisible: true,
    isOpen: false,
    primary_color: '#00A8BE',
    frame_width: '600px',
    brand: 'Help',
    suggestions: tags,
    onButtonHide: () => {
      if (window.hdlh) {
        window.hdlh.isVisible = false;
        if (!window.hdlh.isActiveLightHouse) {
          setIsActiveWidget(false);
        }
      }
    },
    onButtonShow: () => {
      if (window.hdlh) {
        window.hdlh.isVisible = true;
        if (window.hdlh.isActiveLightHouse || window.hdlh.isNavigate) {
          setIsActiveWidget(true);
        } else if (!window.hdlh.isActiveLightHouse) {
          setIsActiveWidget(false);
        }
      }
    },
    onShow: () => {
      if (window.hdlh) {
        window.hdlh.isOpen = true;
      }
      changeZindex('2147483647');
    },
    onHide: () => {
      if (window.hdlh) {
        if (!window.hdlh.isActiveLightHouse) {
          setIsActiveWidget(false);
        }
        window.hdlh.isOpen = false;
      }
      changeZindex();
    },
    onReady: () => {
      if (window.hdlh) {
        setIsActiveWidget(Boolean(window.hdlh.isActiveLightHouse));
      }
      changeZindex();
      if (window.Lighthouse) {
        const defaultNavigate = window.Lighthouse.navigate;
        window.Lighthouse.navigate = (page: string, id?: string) => {
          defaultNavigate(page, id);
          if (window.Lighthouse && window.hdlh) {
            window.hdlh.isNavigate = true;
            window.Lighthouse.show();
            window.Lighthouse.showButton();
          }
        };
      }
    },
  };

  const loadScript = () => {
    const h = 'https://lighthouse.helpdocs.io/load';
    const d = document;
    const s = d.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = `${h}?t=${new Date().getTime()}`;
    d.head.appendChild(s);
  };

  if (document.readyState === 'complete') {
    loadScript();
    // @ts-ignore
  } else if (window.attachEvent) {
    // @ts-ignore
    window.attachEvent('onload', loadScript);
  } else {
    window.addEventListener('load', loadScript,false);
  }
};

export default lightHouse;
